import { useEffect } from 'react'
import { Link, useNavigate, useSearchParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Seo } from '../components/Seo'
import { useAuth } from '../auth/AuthProvider'

/** 后端 /api/auth/callback 失败时会 302 到 /auth/callback?error=...，此页负责展示 */
export function AuthCallback() {
  const { t } = useTranslation()
  const [params] = useSearchParams()
  const navigate = useNavigate()
  const { login } = useAuth()

  const error = params.get('error')
  const errorDescription = params.get('error_description')

  useEffect(() => {
    // 无错误参数时不该停留在此页（后端成功路径直接 302 /records）
    if (!error) navigate('/', { replace: true })
  }, [error, navigate])

  if (!error) return null

  return (
    <main className="page container">
      <Seo title={t('seo.notFoundTitle')} description={errorDescription || t('auth.callbackTitle')} path="/auth/callback" noIndex />
      <div className="card login-card" style={{ maxWidth: 520, margin: '48px auto' }}>
        <div className="icon" aria-hidden="true">⚠️</div>
        <h3>{t('auth.callbackTitle')}</h3>
        <p className="error-text">
          {t('auth.errorPrefix')}: {error}
          {errorDescription ? ` — ${errorDescription}` : ''}
        </p>
        <div style={{ display: 'flex', gap: 10, justifyContent: 'center', flexWrap: 'wrap' }}>
          <button type="button" className="btn primary" onClick={login}>
            {t('auth.retry')}
          </button>
          <Link className="btn ghost" to="/">
            {t('auth.backHome')}
          </Link>
        </div>
      </div>
    </main>
  )
}
